/* istanbul ignore file */

import { mainApi } from "config/api";
import { getClientFor } from "infrastructure/http";

import { IMessage } from "./MessageRelationships.state";

const createGetMessagesFilter = (filter: string) => {
  const params = new URLSearchParams();
  params.append("linked", "false");
  filter && params.append("messageId", filter);

  return params;
};

const buildRequestConfig = (version: number) => ({
  headers: {
    "If-Match": `${version}`
  }
});

export const getNotLinkedMessages = async (filter: string) =>
  (
    await getClientFor(mainApi.name).get<IMessage[]>(`/messages`, {
      params: createGetMessagesFilter(filter)
    })
  ).data;

export const getMessageDetails = async (messageId: string) => (await getClientFor(mainApi.name).get<IMessage>(`/messages/${messageId}`)).data;
export const getRelationships = async (messageId: string) => (await getClientFor(mainApi.name).get<IMessage[]>(`/messages/${messageId}/linked-messages`)).data;

export const addRelationship = async (messageId: string, childMessageId: string, version: number) =>
  await getClientFor(mainApi.name).post(`/messages/${messageId}/synonyms/${childMessageId}`, null, buildRequestConfig(version));

export const deleteRelationship = async (messageId: string, childMessageId: string, version: number) =>
  await getClientFor(mainApi.name).put(`/messages/${messageId}/synonyms/${childMessageId}`, null, buildRequestConfig(version));
